import React from 'react';
import { Icon } from "semantic-ui-react";

import './index.scss';
import { ClippedContent } from '../../atoms/ClippedContent';

const DraggableCall = ({
    dragHandle,
    duration,
    personDisplay,
    isRinging,
    isHeld
}) => {
    return (
        <div className={`DraggableCall`}>
            <div className='DraggableCall__left'>
                {dragHandle}
                <Icon size='large' className={`fa-solid fa-phone-${isRinging ? 'volume' : 'plus'} DraggableCall__status`} />
                <div>
                    <ClippedContent>
                        {<a href="#" type='button'>{personDisplay}</a>}
                    </ClippedContent>
                </div>
            </div>
            <div className={'DraggableCall__right'}>
                {isHeld && <Icon size='large' className='fa-solid fa-play DraggableCall__held-status' />} {duration} 
            </div>
        </div>
    )
}

export default DraggableCall;
